import { z } from "zod";

export const AuditAction = {
	CREATE: "create",
	UPDATE: "update",
	DELETE: "delete",
} as const;

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const AUDIT_ACTIONS = Object.values(AuditAction) as readonly AuditAction[];

export const auditActionSchema = z.enum(AuditAction);
